export const faqBuilder = (content) => {
    return content?.replace(
      /\?\?\?(.*)\?\?\?/g,
      `<h4 class="toggleQuestion">$1</h4>`
    );
  };